import { useEffect, useState } from "react";
import axios from "axios";
import { DepartmentMap } from "../components/DepartmentMap";

const btn = "inline-flex items-center justify-center px-5 py-2.5 rounded-md text-sm font-bold transition-transform hover:-translate-y-0.5";

export default function EmbedCoverage() {
  const [data, setData] = useState(null);
  const [off, setOff] = useState(false);
  useEffect(() => {
    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/coverage`).then((r) => setData(r.data)).catch(() => setOff(true));
  }, []);
  if (off) return <div className="p-6 text-center text-sm text-slate-500" data-testid="embed-off">Carte indisponible.</div>;
  if (!data) return null;
  const color = data.primary_color, origin = window.location.origin, e = data.embed || {};
  return (
    <div className="p-2 bg-transparent" style={{ "--brand-primary": color }} data-testid="embed-coverage">
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-center">
        <div className="sm:col-span-3"><DepartmentMap departments={data.departments} compact /></div>
        <div className="sm:col-span-2">
          <div className="text-sm font-bold mb-2" style={{ color }}>{data.departments.length} département{data.departments.length > 1 ? "s" : ""} couvert{data.departments.length > 1 ? "s" : ""}</div>
          <ul className="flex flex-wrap gap-1.5" data-testid="embed-dept-list">
            {data.departments.map((d) => <li key={d.code} className="text-xs px-2 py-1 rounded border bg-white/70" style={{ borderColor: color }}>{d.name} ({d.code})</li>)}
          </ul>
        </div>
      </div>
      <div className="flex flex-wrap justify-center gap-3 mt-4">
        {e.show_quote && <a data-testid="embed-quote-btn" href={`${origin}/demande-devis`} target="_blank" rel="noopener noreferrer" className={`${btn} text-white`} style={{ backgroundColor: color }}>Demander un devis</a>}
        {e.cta_text && e.cta_url && <a data-testid="embed-cta-btn" href={e.cta_url} target="_blank" rel="noopener noreferrer" className={`${btn} text-white`} style={{ backgroundColor: color }}>{e.cta_text}</a>}
        {e.show_apply && <a data-testid="embed-apply-btn" href={`${origin}/postuler`} target="_blank" rel="noopener noreferrer" className={`${btn} border-2 bg-white/80`} style={{ borderColor: color, color }}>Postuler</a>}
      </div>
    </div>
  );
}
